@if (showField$ | async) {
  <div>
    <editor [formControl]="$any(field.control)" [init]="tinymceInit"></editor>
    <!-- <mat-hint *ngIf="hasDanger()" [ngStyle]="{'color': 'red'}" align="start">{{errorText()}}</mat-hint> -->
    @if (field.help) {
      <mat-hint align="start">{{field.help | translate}}</mat-hint>
    }
  </div>
}